<template>
	<comp-form-default
		ref="formUser"
		v-if="dataForm"
		v-model="validForm"
		:tabActive="tabs.activeTab"
		:tabs="tabsItem" 
		:fields="fields" 
		:dataform="dataForm"
	/>
</template>

<script>
import { itemMixins } from '../settings/functions'

export default {
	mixins: [itemMixins],
	data() {
		return {
			titlePage: 'Añadir usuario nuevo',
		}
	}
}
</script>
